var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { id: "permissions-selection", column: "", "align-center": "" } },
    [
      _vm.accountType !== "clientRole" &&
      _vm.userHasManagementPermission("client_role", "list") &&
      _vm.canSeeTable &&
      !_vm.loading
        ? _c("permissions-client-role", {
            attrs: {
              "client-roles-from-parent": _vm.previousClientRoles,
              "permissions-selected": _vm.permissionsSelectedFromParent,
              "previous-roles-and-permissions": _vm.selectedPermissions,
              "all-permissions": _vm.allPermissions,
              disabled: !_vm.hasPermissionToEdit
            },
            on: {
              "add-select-permissions": _vm.addClientRolesPermissions,
              "remove-select-permissions": _vm.removeClientRolesPermissions,
              "update-client-roles": function($event) {
                return _vm.$emit("selected-client-roles", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.canSeeTable
        ? _c(
            "v-expansion-panels",
            {
              staticClass: "elevation-3 expansion-panel-permission",
              attrs: { multiple: "" },
              model: {
                value: _vm.openedExpansionPanel,
                callback: function($$v) {
                  _vm.openedExpansionPanel = $$v
                },
                expression: "openedExpansionPanel"
              }
            },
            _vm._l(_vm.relevantRoles, function(role) {
              return role.show
                ? _c(
                    "v-expansion-panel",
                    { key: role.name },
                    [
                      _c(
                        "v-expansion-panel-header",
                        [
                          _c("role-item", {
                            attrs: {
                              "role-name": role.name,
                              disabled:
                                !_vm.hasPermissionToEdit ||
                                _vm.userRole === "viewer",
                              "permissions-selected":
                                _vm.selectedPermissions[role.name]
                            },
                            on: {
                              updatePermissions: function($event) {
                                return _vm.updateSelection(role.name, $event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-card",
                            {
                              staticStyle: {
                                "padding-left": "50px",
                                "box-shadow": "none"
                              }
                            },
                            [
                              _c("permissions-list", {
                                attrs: {
                                  role: role.name,
                                  "user-role": _vm.userRole,
                                  disabled: !_vm.hasPermissionToEdit,
                                  "selected-permissions-from-parent":
                                    _vm.selectedPermissions[role.name]
                                },
                                on: {
                                  "update-selection": function($event) {
                                    return _vm.updateSelection(
                                      role.name,
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.canSeeTable ? _c("app-no-permission-warning") : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                height: "100px",
                width: "100%",
                position: "relative"
              }
            },
            [
              _c("loading-spinner", {
                attrs: {
                  active: _vm.loading,
                  "is-full-page": false,
                  color: "#4fa2b7"
                },
                on: {
                  "update:active": function($event) {
                    _vm.loading = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78d5b84d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d5b84d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/Permissions/Permissions.vue
// module id = null
// module chunks = 